import globals from "@lvt/globals";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";
import qs from "qs";

import { archiveCabinetsValidator } from "@/api/map/archiveCabinets/archiveCabinetSchema";
import { ArchiveCabinet, FilterConfig } from "@/api/map/types";

import { validateRequest } from "../../common";


export const fetchArchiveCabinets = createAsyncThunk(
    "fetchArchiveCabinets",
    async (filterConfig: FilterConfig, { dispatch }) => {
        const client = applyCaseMiddleware(
            axios.create({
                baseURL: globals.userdashboard.proxyUrl,
            }),
        );

        // QS to properly format query string parameters
        client.interceptors.request.use((config) => {
            config.paramsSerializer = (params) => {
                return qs.stringify(params, {
                    arrayFormat: "brackets",
                    encode: false,
                });
            };

            return config;
        });

        const request = client.get("/api/vms/archive_cabinets", {
            withCredentials: true,
            params: filterConfig,
        });

        return await validateRequest<Array<ArchiveCabinet>>(
            dispatch,
            request,
            archiveCabinetsValidator,
            "Failed to get archive cabinets",
        );
    },
);
